import React, { useEffect, useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@material-ui/core';
import { globalGetService } from '../../../utils/globalApiServices';
import { checkApiStatus } from '../../../utils';
import { getAssetTypeUrl } from '../../../constants';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import { TimelineOppositeContent } from '@material-ui/lab';
import { AttachmentsRow, LabelValueCard ,EmptyCollection} from '../../../shared_elements';
import moment from 'moment';
import { STableLoader } from '../../../shared_elements/loaders';
import { useSnackbar } from 'notistack';

export default function TimelineModal({ modal, toggleModalFn,assemblyType, propsParams,pageTitle,claimId }) {
  const [pageLoader, setPageLoader] = useState(false);
  const [timeLineData, setTimeLineData] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => {
    if (modal) {
      setTimeLineData([]);
      getTimeLineData();
    }
  }, [modal]);
  const getTimeLineData = () => {
    const { assetSlug, id } = propsParams;
    const getStatusTimelineUrl = (pageTitle, assetSlug, propsParams) => {
      if (pageTitle === "Claim") {
        return {
          url: `maintenance/${assemblyType}/asset/${assetSlug}/claims/${claimId}/status-time-line/`,
        };
      } else {
        return {
          url: `maintenance/asset-type/${getAssetTypeUrl[propsParams?.assetType]}/asset/${assetSlug}/shopvisit/${id}/status-time-line/`,
        };
      }
    };

    const { url } = getStatusTimelineUrl(pageTitle, assetSlug, propsParams);
    setPageLoader(true);
    globalGetService(url)
      .then(response => {
        setPageLoader(false);
        if (checkApiStatus(response)) {
          setTimeLineData(response.data.data);
        } else {
          enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        }
      })
  }
  return (
    <Dialog
      open={modal}
      maxWidth="lg"
      onClose={() => toggleModalFn()}
      aria-labelledby="scroll-dialog-title"
    >
      <DialogTitle id="scroll-dialog-title">
        {pageTitle} Status Timeline
      </DialogTitle>
      <DialogContent dividers={true} style={{ width: '1100px' }}>
        {pageLoader ? <STableLoader count={6} /> : null}
        {timeLineData?.length> 0  ?   <div>
          <Timeline align="left" >
            {timeLineData.map((item, index) =>
              <TimelineItem>
                <TimelineOppositeContent style={{ flex: 0 }} > </TimelineOppositeContent>
                <TimelineSeparator>
                  <TimelineDot style={{ background: "#89bfff" }} />
                  {(timeLineData.length - 1) > index ?
                    <>
                      <TimelineConnector />
                      <span className='arrow-corner-block-div' > {'>'}</span>
                    </>
                    : null}
                </TimelineSeparator>
                <TimelineContent>
                  <Grid container spacing={3}>
                    <LabelValueCard md={2} label='Status From' value={item?.payout_status_from?.label ?item?.payout_status_from?.label :  item.status_from?.label ? item?.status_from?.label : '--'} />
                    <LabelValueCard md={2} label='Status To' value={item?.payout_status_to?.label ?item?.payout_status_to?.label :item.status_to?.label ? item?.status_to?.label : '--'} />
                    <LabelValueCard md={2} label='Changed by' value={item.changed_by?.name ? item?.changed_by?.name : '--'} />
                    <LabelValueCard md={2} label='Created at' value={item.created_at ? moment(item.created_at).format('MMM DD, YYYY') : '--'} />
                    <LabelValueCard md={2} label='Comments' value={item.comment ? item?.comment : '--'} />
                    <LabelValueCard md={2} label='Attachments' value={item.attachments?.length ?
                      <AttachmentsRow attachmentsData={item?.attachments} /> : '--'} />
                  </Grid>
                </TimelineContent>
              </TimelineItem>
            )}
          </Timeline>
        </div> : pageLoader ? null : <EmptyCollection
                  title="No Records Found"
                />}
      
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' color="primary" onClick={() => { toggleModalFn() }}>Okay</Button>
      </DialogActions>
    </Dialog>
  )
}
